import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Grid, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { ServidoresScreen } from "../screens/servidoresScreen";
import { ApisScreen } from "../screens/apisScreen";
import { DsKeyScreen } from "../screens/dsKeyScreen";
import { CRMScreen } from "../screens/CRMScreen";

const useStyles = makeStyles()(theme => ({
    tab: {
        borderRadius: '15px',
        '&.Mui-selected': {
            backgroundColor: 'white',
            border: '1px solid #EEEEEE'
        },
    },
    tabIndicator: {
        backgroundColor: theme.palette.primary.main,
        height: '4px',
    },
    defaultTabPanel: {
        marginTop: theme.spacing(2),
        backgroundColor: 'white',
        borderRadius: '15px',
        border: '1px solid #CECECE',
        overflow: 'auto',
        maxHeight: 'calc(100% - 50px)'
    },
    minimalTabPanel: {
        paddingBlock: theme.spacing(2),
        paddingInline: theme.spacing(0),
        overflow: 'auto',
        maxHeight: 'calc(100% - 50px)'
    },
    container: {
        width: '100%',
        height: '100%'
    }
}));

const tabValues = [
    { name: "Servidores", component: <ServidoresScreen />, hasMinimalTabPanel: false},
    { name: "APIs", component: <ApisScreen />, hasMinimalTabPanel: false},
    { name: "DsKey", component: <DsKeyScreen/>, hasMinimalTabPanel: true },
    { name: "CRM", component: <CRMScreen/>, hasMinimalTabPanel: true },
];

const DashboardView: React.FC = () => {
    const { classes } = useStyles();
    const [screen, setScreen] = useState(tabValues[0].name);
    const handleChangeScreen = (event: React.SyntheticEvent, value: string) => {
        setScreen(value)
    };

    return (
        <Grid container padding={2} margin={0} className={classes.container}>
            <Box sx={{ width: '100%', maxHeight: '100%'}}>
                <TabContext value={screen} >
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChangeScreen} >
                            {tabValues.map(({ name }) => (
                                <Tab key={name} label={name} value={name} className={classes.tab} />
                            ))}
                        </TabList>
                    </Box>
                    {tabValues.map(({ name, component, hasMinimalTabPanel }) => (
                        <TabPanel key={name} value={name} className={hasMinimalTabPanel? classes.minimalTabPanel: classes.defaultTabPanel}>
                            {component}
                        </TabPanel>
                    ))}
                </TabContext>
            </Box>
        </Grid>
    )
};

export default DashboardView;